export default "__VITE_ASSET__BEP4U9Cy__"